var _path, _g, _g2, _g3, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.165,
    height: 38.814,
    viewBox: "0 0 30.165 38.814",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "zip",
    transform: "translate(-250.815 -1177.348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2026",
    "data-name": "Group 2026",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2074",
    "data-name": "Path 2074",
    d: "M271.78,1177.348H252.929v38.814H280.98v-29.757Z",
    fill: "#5d5d5d"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2027",
    "data-name": "Group 2027"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2075",
    "data-name": "Path 2075",
    d: "M271.78,1177.348l9.2,9.068h-9.2Z",
    fill: "#5d5d5d"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2028",
    "data-name": "Group 2028"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1462",
    "data-name": "Rectangle 1462",
    width: 28,
    height: 13.286,
    transform: "translate(250.815 1195.54)",
    fill: "#379836"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2029",
    "data-name": "Group 2029"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2076",
    "data-name": "Path 2076",
    d: "M250.815,1208.824l2.128,1.8v-1.8Z",
    fill: "#3e993b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_.zip",
    "data-name": " .zip",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2030",
    "data-name": "Group 2030",
    style: {
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2077",
    "data-name": "Path 2077",
    d: "M257.15,1205.95a.66.66,0,0,1,.468-1.128.606.606,0,0,1,.452.192.682.682,0,0,1,0,.936.609.609,0,0,1-.452.191A.636.636,0,0,1,257.15,1205.95Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2078",
    "data-name": "Path 2078",
    d: "M260.309,1205.28h2.861v.8H259.2v-.8l2.829-4.245h-2.808v-.787h3.925v.787Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2079",
    "data-name": "Path 2079",
    d: "M264.5,1199.11a.659.659,0,0,1,.467-1.127.608.608,0,0,1,.452.191.679.679,0,0,1,0,.936.6.6,0,0,1-.452.192A.633.633,0,0,1,264.5,1199.11Zm.936,1.138v5.829h-.969v-5.829Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2080",
    "data-name": "Path 2080",
    d: "M268.951,1200.488a2.555,2.555,0,0,1,1.324-.335,2.731,2.731,0,0,1,1.41.372,2.622,2.622,0,0,1,.994,1.048,3.274,3.274,0,0,1,.362,1.569,3.347,3.347,0,0,1-.362,1.574,2.651,2.651,0,0,1-2.4,1.457,2.548,2.548,0,0,1-1.314-.335,2.383,2.383,0,0,1-.866-.835v3.84h-.968v-8.595h.968v1.075A2.3,2.3,0,0,1,268.951,1200.488Zm2.835,1.505a1.849,1.849,0,0,0-.718-.745,1.991,1.991,0,0,0-.995-.255,1.934,1.934,0,0,0-.984.261,1.907,1.907,0,0,0-.723.755,2.569,2.569,0,0,0,0,2.3,1.911,1.911,0,0,0,.723.756,1.934,1.934,0,0,0,.984.26,1.956,1.956,0,0,0,.995-.26,1.88,1.88,0,0,0,.718-.756,2.425,2.425,0,0,0,.266-1.164A2.372,2.372,0,0,0,271.786,1201.993Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.d9278233eec16b47b94c50b49c6bbb50.svg";
export { ForwardRef as ReactComponent };